export const calcAge = (birthDate, examDate) => {
  if (!birthDate) return null;
  const birth = new Date(birthDate);
  const exam = examDate ? new Date(examDate) : new Date();
  let age = exam.getFullYear() - birth.getFullYear();
  if (
    exam.getMonth() < birth.getMonth() ||
    (exam.getMonth() === birth.getMonth() && exam.getDate() < birth.getDate())
  ) {
    age--;
  }
  return age;
};

export const formatDateEU = (isoDate) => {
  if (!isoDate) return "";
  const [y, m, d] = isoDate.split("-");
  return `${d}.${m}.${y.slice(2)}`;
};
